import { useContext } from 'react';
import { PartnerFormContext } from '../context/PartnerFormContext.jsx';

export const usePartnerForm = () => {
    const context = useContext(PartnerFormContext);
    if (!context) {
        throw new Error(
            'usePartnerForm must be used within a PartnerFormProvider',
        );
    }
    return context;
};
